import "core-js";
import "whatwg-fetch";

import ready from "./core/ready";
// import * as $ from "jquery"

import FixedHeader from "./components/fixed-header";
import TouchMenu from "./components/touch-menu";
import GeckoSlideshow from "./components/gecko-slideshow";

import Konami from "./core/konami";

import "./weak";

ready(() => {
	console.log("Ready!");

	const menu = TouchMenu.searchAndLoadOne();

	FixedHeader.searchAndLoad()
		.forEach(header => {
			header.watch();

			const toggleEl = header.element.querySelector(`[data-action="toggle-touch-menu"]`);

			if (toggleEl) {
				toggleEl.addEventListener("click", () => {
					menu.toggle();
				});
			}
		});

	GeckoSlideshow.searchAndLoad()
		.forEach(slideshow => {
			slideshow.reify();
		});

	Konami.init();
	Konami.hook(() => {
		document.documentElement.classList.add("konami");
	});



	/*let backToTop = document.querySelector('.back-to-top');
	if(backToTop) {
		backToTop.addEventListener("click", (e) => {
			e.preventDefault();
			jQuery("body").animate({"scrollTop": "0px"}, 800);
		});
	}*/


	let headerSearchTrigger = document.getElementById('header-search-trigger');
	let headerSearchForm = document.querySelector('header form.header-search');
	let headerSearchInput = <HTMLInputElement> headerSearchForm.querySelector('input[name="s"]');
	if(headerSearchTrigger) {
		headerSearchTrigger.addEventListener('click', (e) => {
			e.preventDefault();
			console.log("CLICK");
			if(headerSearchForm.hasAttribute('data-status')) {
				headerSearchForm.removeAttribute('data-status');
			} else {
				headerSearchForm.setAttribute('data-status', 'active');
				headerSearchInput.focus();
			}
		});
	}
});